// @flow

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';
import type { History } from 'react-router-dom';
import { components, elements, colors, fonts, copy } from '@peachjar/components';
import { css, cx } from 'react-emotion';

import WhiteSpaceSvgWrapper from '../../../../../components/WhiteSpaceSvgWrapper';
import Email from '../../../../../components/Email.svg';
import sendDistrictMagicLinkEmail from '../utils/sendDistrictMagicLinkEmail';

const { FullSpread, ContentColumn, WhitespaceColumn } = components;
const { ButtonSecondarySmall } = components.Buttons;
const { jungle, prussian, platinum } = colors;
const { ProximaNova } = fonts;
const { Notifications } = components;
const { Paragraph, Headline1 } = elements.typography;
const { notifySuccess, notifyError } = Notifications;
const { quotes } = copy;

const styles = {
  header: css({
    fontSize: '34px',
    fontFamily: ProximaNova,
    fontWeight: 500,
    color: prussian,
    maxWidth: '420px',
    marginBottom: '16px',
  }),
  container: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
  resendText: css({
    fontSize: '13px',
    fontFamily: ProximaNova,
    color: prussian,
    marginTop: 0,
    marginBottom: 0,
  }),
  resendBox: css({
    display: 'flex',
    justifyContent: 'space-between',
    height: '69px',
    backgroundColor: platinum,
    padding: '1rem',
    alignItems: 'center',
    marginTop: '0.5rem',
  }),
  jungleClass: css({ color: jungle }),
  marginTopZero: css({ marginTop: '0' }),
  marginBottomZero: css({ marginBottom: '0' }),
  paddingBottom: css({ paddingBottom: '1rem' }),
};

type Props = {|
  +formValues: {
    email: string,
  },
  +onNotifySuccess: string => void,
  +onNotifyError: string => void,
  +hasPaidAndSigned: boolean,
  +previousPage: () => void,
  +history: History,
|};

export class VerifyEmailContainer extends Component<Props> {
  resendMagicLink = () => {
    // if if formValues not available, pull from database
    const email =
      this.props.formValues.email ||
      get(this.props.data, 'schoolOrDistrictRegistration.registrant.email');

    sendDistrictMagicLinkEmail(email, this.props.hasPaidAndSigned)
      .then(
        this.props.onNotifySuccess('The verification email has been resent.')
      )
      .catch(err => this.props.onNotifyError(`Could not send email! ${err}`));
  };

  render() {
    const { previousPage, history } = this.props;
    return (
      <FullSpread>
        <ContentColumn
          className={styles.paddingBottom}
          onClick={() => history.push('/onboarding')}
        >
          <div className={styles.container}>
            <Headline1 className="mb-3">Verify your email.</Headline1>
            <Paragraph>A verification email has been sent to:</Paragraph>
            <Paragraph className={cx(styles.jungleClass, 'mb-3')}>
              {this.props.formValues.email}
            </Paragraph>
            <Paragraph className="mb-3">
              Please check your email and follow the link to activate your
              account.
            </Paragraph>
            <div className={styles.resendBox}>
              <Paragraph className={styles.resendText}>
                Didn&apos;t get it? Resend the verification email.
              </Paragraph>
              <ButtonSecondarySmall
                className="ml-3"
                data-testid="click-resendVerificationEmail"
                onClick={this.resendMagicLink}
              >
                Resend
              </ButtonSecondarySmall>
            </div>
          </div>
        </ContentColumn>
        <WhitespaceColumn>
          <WhiteSpaceSvgWrapper
            svg={<Email />}
            quote={quotes.duncan_cutsThroughTheClutter}
          />
        </WhitespaceColumn>
      </FullSpread>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onNotifySuccess: message => dispatch(notifySuccess(message)),
  onNotifyError: message => dispatch(notifyError(message)),
});

const mapStateToProps = state => {
  const form = state.form.onboarding;
  const values = form && form.values;

  return {
    formValues: { ...values },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VerifyEmailContainer)
);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/UserRegistration/containers/VerifyEmailContainer.jsx